var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JoszakiCard',[_c('content-placeholders',{staticClass:"grid grid-cols-[auto_1fr] gap-2"},[_c('content-placeholders-img',{staticClass:"!h-9 !w-9 [clip-path:circle(50%_at_50%_50%)] float-right"}),_c('div',[_c('content-placeholders-heading'),_c('content-placeholders-text',{attrs:{"lines":2}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }